import AiboxUnify from './src/main';

/* istanbul ignore next */
AiboxUnify.install = function(Vue) {
  Vue.component(AiboxUnify.name, AiboxUnify);
};

export default AiboxUnify;
